import { render, staticRenderFns } from "./OrderCheck.vue?vue&type=template&id=6f1559c5&scoped=true&"
import script from "./OrderCheck.vue?vue&type=script&lang=js&"
export * from "./OrderCheck.vue?vue&type=script&lang=js&"
import style0 from "./OrderCheck.vue?vue&type=style&index=0&id=6f1559c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1559c5",
  null
  
)

export default component.exports